/** Compensa a navbar fixa ao fazer scroll para secções. */
export const NAV_SECTION_SCROLL_OFFSET = 100;

/**
 * @param {string} [sectionId] — id do elemento (sem #). Vazio = topo da página.
 */
export function scrollToSectionId(sectionId) {
    if (!sectionId) {
        window.scrollTo({ top: 0, behavior: "smooth" });
        return;
    }
    const el = document.getElementById(sectionId);
    if (!el) return;
    const top = el.getBoundingClientRect().top + window.scrollY - NAV_SECTION_SCROLL_OFFSET;
    window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
}

/**
 * @param {string} to — ex. "/#vips" ou "/"
 * @returns {{ path: string, hash: string }}
 */
export function parseNavHashTo(to) {
    const hashIdx = to.indexOf("#");
    if (hashIdx === -1) {
        return { path: to || "/", hash: "" };
    }
    return {
        path: to.slice(0, hashIdx) || "/",
        hash: to.slice(hashIdx + 1),
    };
}
